import { useEffect, useState } from 'react';
import { SceneBack } from '@/shared/components/SceneBack';
import { CraftModal } from '../components/CraftModal';
import { WorldviewList } from '../components/WorldviewList';

export function Worldview() {
  const [craftOpen, setCraftOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    document.title = 'Craft Your World View — The Arena';
  }, []);

  const handleClose = () => {
    setCraftOpen(false);
    setRefreshKey((k) => k + 1);
  };

  return (
    <main className="scene">
      <div
        className="scene__image scene__image--worldview"
        role="img"
        aria-label="A grand celestial library bathed in light"
      />
      <div className="scene__vignette" />

      <SceneBack />

      <div className="scene__content">
        <p className="scene__eyebrow">— The Library —</p>
        <h1 className="scene__title">Write the Soul</h1>
        <p className="scene__subtitle">Digitize how you reason. Take it anywhere.</p>

        <button
          type="button"
          className="scene__cta"
          onClick={() => setCraftOpen(true)}
        >
          Craft
        </button>

        <WorldviewList refreshKey={refreshKey} />
      </div>

      <CraftModal open={craftOpen} onClose={handleClose} />
    </main>
  );
}
